import type { Modification } from '../../types';
import { checkIfDressingIngredient } from './check-if-dressing-ingredient';

export function checkIfMixableDressingIngredient(modification: Modification) {
  const { ingredient } = modification;

  if (!ingredient) return false;

  const { isMixable } = ingredient;

  const isIngredientMixable = isMixable ?? false;
  const isDressing = checkIfDressingIngredient(modification);

  return isDressing && isIngredientMixable;
}
